export default __webpack_public_path__ + "static/media/email_icon.a7f4e04a.svg";